import React, {useEffect} from "react";
import {FixedSizeList} from "react-window";

import {OptionalContent} from "../../../../components/OptionalContent";
import {useQuotes} from "../../QuotesContext";
import {quoteItemHeight, QuotesBlock, QuotesBlockSkeleton} from "./QuoteItem";
import QuoteSearchTools from "./QuoteSearchTools";
import "./quoteIndexScrollBar.css"

import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import LinearProgress from "@mui/material/LinearProgress";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import AutoSizer from "react-virtualized-auto-sizer";
import Box from "@mui/material/Box";


const QuotesIndex = () => {
    const {formQuote, quotesPagination} = useQuotes();

    useEffect(
        () => {
            if (!quotesPagination.isInitialized) {
                quotesPagination.initialize();
            }
        },
        []  // eslint-disable-line react-hooks/exhaustive-deps
    );

    return <Container maxWidth="md" disableGutters={true}>

        <Card sx={{mt: 3}}>
            <QuoteSearchTools/>
        </Card>

        <Box sx={{mt: 3, height: "calc(100vh - 300px)" /* -300 to account for card padding, margin, headers, ... */}}>
            <AutoSizer disableWidth>
                {
                    ({height}) => (
                        <Card>
                            <List sx={{position: "relative"}}>
                                {
                                    !quotesPagination.isInitialized ?
                                        <>
                                            <LinearProgress
                                                sx={{position: "absolute", top: 0, right: 0, left: 0}}/>
                                            <QuotesBlockSkeleton/>
                                        </>
                                        :
                                        <OptionalContent hasContent={quotesPagination.itemsCount > 0}
                                                         noContentMessage="Nessun preventivo presente"
                                                         showIcon>
                                            <FixedSizeList
                                                height={height}
                                                itemCount={quotesPagination.pagesCount}
                                                itemSize={quoteItemHeight * quotesPagination.pageSize}
                                                width="100%"
                                                className="quotes-container">
                                                {QuotesBlock}
                                            </FixedSizeList>
                                        </OptionalContent>
                                }
                            </List>
                        </Card>
                    )
                }
            </AutoSizer>
        </Box>

        <Fab variant="extended"
             color="primary"
             size='medium'
             sx={{position: "fixed", bottom: 0, right: 0, mr: {xs: 2, md: 4}, mb: {xs: 2, md: 4}}}
             onClick={() => formQuote.open()}>
            <AddIcon sx={{mr: 1}}/>
            Aggiungi
        </Fab>
    </Container>
}

export default QuotesIndex;